export default __webpack_public_path__ + "0235a8b41c610e83a8b1b4db97fc0bd6.svg";